



import baseAPI from '@/http'

const router = 'api/usuarioPermissaoMunicipioSolucao'

export const usuarioPermissaoMunicipioSolucaoApi = {
    list: (municipioId, municipioSolucaoId) => baseAPI.get(`${router}/get-usuarios-by-municipio/${municipioId}/${municipioSolucaoId}`),

}
